import classes from './Tabs.module.scss';
import Link from 'next/link';
import { withRouter } from 'next/router';
import General from './general/General';
import Chats from './chats/Chats';
import Pricing from './pricing/Pricing';
import Security from './security/Security';
import Notifications from './notifications/Notifications';

const Tab = ({ router, props }) => {
    const { general, chats, security, pricing, notifications, tabs } = props?.data?.attributes;

    const GENERAL = tabs[0].title;
    const CHATS = tabs[1].title;
    const SECURITY = tabs[2].title;
    const PRICING = tabs[3].title;
    const NOTIFICATIONS = tabs[4].title;

    const tabsText = [GENERAL, CHATS, SECURITY, PRICING, NOTIFICATIONS];

    const {
        query: { tab = GENERAL, lang }
    } = router;

    const displayTab = () => {
        switch (tab) {
            case GENERAL:
                return <General data={general} />;
            case CHATS:
                return <Chats data={chats} />;
            case SECURITY:
                return <Security data={security} />;
            case PRICING:
                return <Pricing data={pricing} />;
            case NOTIFICATIONS:
                return <Notifications data={notifications} />;
            default:
                return <General data={general} />;
        }
    };

    return (
        <div className={classes.TabContainer}>
            <div className={`${classes.TabHead} ${classes.oTabs}`}>
                {tabsText?.map((tabTitle, index) => (
                    <div key={index} className={classes.mTab}>
                        <Link href={{ pathname: '/faqs', query: { lang, tab: tabTitle } }}>
                            <a id={tabTitle} className={`${classes.faqsLink}  fnt18f`}>
                                {tabTitle}
                            </a>
                        </Link>
                    </div>
                ))}
            </div>
            <div className={classes.TabBody}>{displayTab()}</div>
            <style jsx>{`
                #${tab} {
                    text-decoration: underline !important;
                    font-weight: 700;
                    color: '#29b2ff !important';
                }
            `}</style>
        </div>
    );
};

export default withRouter(Tab);
